import { useQuery } from "@tanstack/react-query";

import { useSearchUser } from "../../../hooks/useSearchUser";

const useStudentDetailsQuery = ({
  stateStudentData,
  vertical,
  decryptedPhone,
  urlUamId,
  urlAdmissionNumber,
}) => {
  const { mutateAsync } = useSearchUser();
  const shouldFetch =
    !stateStudentData &&
    !!vertical &&
    (!!decryptedPhone || !!urlUamId || !!urlAdmissionNumber);

  const query = useQuery({
    queryKey: [
      "studentDetails",
      vertical,
      decryptedPhone,
      urlUamId,
      urlAdmissionNumber,
    ],
    queryFn: () =>
      mutateAsync({
        vertical,
        searchParams: {
          phone: decryptedPhone,
          uam_id: urlUamId,
          admission_number: urlAdmissionNumber,
        },
      }),
    enabled: shouldFetch,
    retry: false,
  });

  return { ...query, shouldFetch };
};

export default useStudentDetailsQuery;
